import React, { memo } from 'react';
import { Sparkles } from 'lucide-react';
export function AhaSection() {
  return <section className="py-20 px-4 bg-[#5C6B60] text-white text-center" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-3">
          <Sparkles className="w-6 h-6 text-[#F5F1EA]" data-id="element-4" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-heading leading-tight" data-id="element-5">
          La mayoría de los niños no tienen un problema de inteligencia.
        </h2>

        <p className="text-lg md:text-xl text-[#F5F1EA]/90 leading-relaxed max-w-2xl mx-auto" data-id="element-6">
          Lo que tienen es una confusión de métodos. Han intentado memorizar
          palabras completas sin entender cómo se construyen. El secreto no es
          más práctica forzada, es la{' '}
          <span className="font-bold text-[#F5F1EA] bg-[#C2644C]/80 px-2 py-0.5 rounded" data-id="element-7">
            activación incorrecta
          </span>{' '}
          de los sonidos en el{' '}
          <span className="font-bold text-[#F5F1EA] bg-[#C2644C]/80 px-2 py-0.5 rounded" data-id="element-8">
            orden correcto
          </span>
          .
        </p>
      </div>
    </section>;
}